export const UNIFIED_PRODUCTS_COLUMNS_KEYS = Object.freeze({
  NAME: 'name',
  TYPE: 'type',
  CREATED_AT: 'createdAt',
  CONTRACTS: 'contractsCount',
  ACTIONS: 'actionMenu',
});
